import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import auth from "../../../shared/mobx/auth-state";
import { Link } from 'react-router-dom';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import LoginHeader from './LoginHeader';
import classNames from 'classnames';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';

const ForgotPassword = () => {

    const [isLoading, setIsLoading] = useState(false);
    return (
        <PageWrapper
            isProtected={false}
            title={true ? 'Forgot Password' : 'Login'}
            className={classNames({ 'bg-dark': !true, 'bg-light': true })}>
            <Page className='p-0'>
                <div className='row h-100 align-items-center justify-content-center'>
                    <div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
                        <Card className='shadow-3d-dark' data-tour='login-page'>
                            <CardBody>
                                {/* <div className='text-center my-5'>
                                <Link
                                    to='/'
                                    className={classNames(
                                        'text-decoration-none  fw-bold display-2',
                                        {
                                            'text-dark': !darkModeStatus,
                                            'text-light': darkModeStatus,
                                        },
                                    )}
                                    aria-label='Facit'>
                                    <Logo width={200} />
                                </Link>
                            </div>
                            <div
                                className={classNames('rounded-3', {
                                    'bg-l10-dark': !darkModeStatus,
                                    'bg-dark': darkModeStatus,
                                })}>
                                <div className='row row-cols-2 g-3 pb-3 px-3 mt-0 mb-2'>
                                    <div className='col'>
                                        <Button
                                            color={darkModeStatus ? 'light' : 'dark'}
                                            isLight={true}
                                            className='rounded-1 w-100'
                                            size='lg'
                                            tag='a'
                                            to='/auth/login'
                                        // onClick={() => {
                                        // 	setSignInPassword(false);
                                        // 	settrue(!true);
                                        // }}>
                                        >
                                            Login
                                        </Button>
                                    </div>
                                    <div className='col'>
                                        <Button
                                            tag='a'
                                            color={darkModeStatus ? 'light' : 'dark'}
                                            isLight={!true}
                                            className='rounded-1 w-100'
                                            size='lg'
                                            // onClick={() => {
                                            // 	setSignInPassword(false);
                                            // 	settrue(!true);
                                            // }}>
                                            to='/auth/sign-up'
                                        >
                                            Sign Up
                                        </Button>
                                    </div>
                                </div>
                            </div> */}

                                <LoginHeader isNewUser={true} isForgotPassword={true} />

                                <Formik
                                    initialValues={{ email: '' }}
                                    validationSchema={Yup.object({
                                        email: Yup.string().email('Email must be a valid email').required('Email is a required field'),
                                    })}
                                    onSubmit={async (values, { setSubmitting }) => {
                                        setIsLoading(true);
                                        try {
                                            await auth.doForgotPassword(values);
                                            // Additional logic if needed after submitting forgot password
                                        } catch (error) {
                                            console.error('Forgot Password failed:', error);
                                        }
                                        setIsLoading(false);
                                        setSubmitting(false);
                                    }}
                                >
                                    {({ values, touched, errors, isValid, handleChange, handleBlur, isSubmitting, setErrors }) => (
                                       
                                        <Form>
                                            <div className="row">
                                                <div className="col-12">
                                                <FormGroup label="Email" isFloating >
                                                <Input
                                                    value={values.email}
                                                    isTouched={touched.email}
                                                    invalidFeedback={errors.email}
                                                    isValid={isValid}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onFocus={() => {
                                                        setErrors({});
                                                    }}
                                                    type='email'
                                                    autoComplete='email'
                                                    name='email'
                                                />
                                               
                                            </FormGroup>
                                                </div>
                                                <div className='col-12'>
                                                    <button
                                                        type='submit'
                                                        className='btn btn-info auth-btn w-100 p-3 mt-4 mb-3 m-0'
                                                        disabled={isSubmitting || isLoading}>
                                                        {isSubmitting || isLoading ? "Submitting..." : "Submit"}
                                                    </button>
                                                </div>

                                                <div className="col-12">
                                                    
                                            <div className="text-center">
                                                <Link to="/auth/login" className="text-decoration-none">
                                                    Remembered your password? Login here.
                                                </Link>
                                            </div>
                                                </div>

                                            </div>




                                        </Form>
                                    )}
                                </Formik>
                            </CardBody>
                        </Card>
                    </div>
                </div>

            </Page>
        </PageWrapper>
    );
};

export default ForgotPassword;
